import { render } from "./PlaceholderText.vue?vue&type=template&id=0725aba2&ts=true"
import script from "./PlaceholderText.vue?vue&type=script&lang=ts"
export * from "./PlaceholderText.vue?vue&type=script&lang=ts"

import "./PlaceholderText.vue?vue&type=style&index=0&id=0725aba2&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__